import React from 'react';
import { DrawerHelper } from '@helpers';

export const useDrawer = (name: string) => {
	const hide = React.useCallback((): void => {
		DrawerHelper.hide(name);
	}, [name]);

	const show = React.useCallback((): void => {
		DrawerHelper.show(name);
	}, [name]);

	return React.useMemo(
		() => ({
			hide,
			show,
		}),
		[hide, show]
	);
};
